import type { UserRole } from "@/lib/auth";

/**
 * 権限区分の表示名と、何ができるか。
 *
 * API の UserRole（ADMIN > LEADER > OPERATOR > VIEW）と対応させる。説明は
 * 選択肢に添えて、どれを選べばよいか迷わせないためのもの。
 */
export const ROLE_OPTIONS: {
  key: UserRole;
  label: string;
  description: string;
}[] = [
  { key: "admin", label: "管理者", description: "ユーザー管理・マスタ編集ができる" },
  { key: "leader", label: "リーダー", description: "見積・案件・図面を編集できる" },
  { key: "operator", label: "オペレーター", description: "工数・作業実績を入力できる" },
  { key: "view", label: "閲覧", description: "参照のみ" },
];

export const ROLE_LABEL: Record<UserRole, string> = Object.fromEntries(
  ROLE_OPTIONS.map((o) => [o.key, o.label]),
) as Record<UserRole, string>;
